import React from "react";
import { useSelector } from "react-redux";
import { reduxForm, Field, isValid, SubmissionError } from "redux-form";
import { Button, ReduxControls, ErrorBanner } from "rhombus-react";

import BasicModal from "widgets/modals/BasicModal";
import { YOUTUBE_URL_FORM } from "utils/forms";
import { createYoutubeUrlCreative } from "reducers/creatives/YoutubeUrl";
import { creativeNameAllowedChars, creativeNameMaxLength, youtubeURL } from "widgets/forms/validators/Creatives";
import { requiredNotNull } from "widgets/forms/validators/validators";
import ProgressContainer from "widgets/ProgressContainer";
import { toFriendlyErrorMessage } from "utils/common";

import "./YoutubeURLForm.css";

const validForm = isValid(YOUTUBE_URL_FORM);

function YoutubeURLFormFields(props){
	let { handleSubmit, error } = props
		, isSaving = useSelector(state => state.creatives?.isSavingYoutubeUrlCreative ?? false)
		, errorBanner = null
		;

	if(error){
		errorBanner = (
			<ErrorBanner
				type="youtubeUrlError"
				title="Sorry, please fix the errors below and try again."
				messages={[error]}
			/>
		);
	}

	return (
		<ProgressContainer isLoading={isSaving}>
			<form
				id={YOUTUBE_URL_FORM}
				className="redux-form-container youtube-url-form"
				onSubmit={handleSubmit}
			>
				<header className="header-bar">Enter YouTube URL</header>
				<div className="youtube-url-fields">
					{errorBanner}
					<Field
						component={ReduxControls.Input}
						className="creative-name"
						name="name"
						label="Creative Name"
						required
						validate={[requiredNotNull, creativeNameAllowedChars, creativeNameMaxLength]}
						placeholder="Enter Creative Name..."
					/>
					<Field
						component={ReduxControls.Input}
						className="youtube-url"
						name="youtubeUrl"
						label="YouTube URL"
						required
						validate={[requiredNotNull, youtubeURL]}
						placeholder="Enter YouTube URL..."
					/>
				</div>
			</form>
		</ProgressContainer>
	);
}

YoutubeURLFormFields.displayName = "YoutubeURLFormFields";

function onSubmit(values, dispatch, formProps){
	return dispatch(createYoutubeUrlCreative(formProps.libraryId, { name:values.name, youtubeUrl:values.youtubeUrl }))
		.then((resp) => {
			if(resp.success){
				formProps.onClose();
				return resp;
			}

			let description = resp.payload.errorObj?.description;

			throw new SubmissionError({
				_error:description ? toFriendlyErrorMessage(description) : "Error creating YouTube URL creative.",
			});
		});
}

const ConnectedYoutubeURLForm = reduxForm({
	form: YOUTUBE_URL_FORM,
	onSubmit,
})(YoutubeURLFormFields);

export const PRIVATE = { onSubmit };

export default function YoutubeURLForm(props){
	let {
			navigationActions,
			commonModalProps,
			libraryId,
		} = props
		, { popModal } = navigationActions
		, isValidForm = useSelector(validForm)
		;

	function renderContent(){
		return <ConnectedYoutubeURLForm libraryId={libraryId} onClose={commonModalProps.onClose} />;
	}

	function renderFooter(){
		return [
			<Button
				key="back"
				theme="default"
				onClick={popModal}
			>
				Back
			</Button>
			, <Button
				key="submit"
				theme="green"
				type="submit"
				form={YOUTUBE_URL_FORM}
				disabled={!isValidForm}
			>
				Create YouTube URL Creative
			</Button>
		];
	}

	const modalProps = {
		title: "Create VAST",
		className: "basic-modal youtube-url-form-modal",
		onClose: commonModalProps.onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

YoutubeURLForm.displayName = "YoutubeURLForm";
